import { ApiError } from '@gorila-shared-ui/components';
import { AssetState } from '../types/currentState';
import { getRequest } from './api';
import { assetStateUrl } from './urls/assetStateUrls';

export const getAssetState = async (
  clientId: string,
  assetId: string,
  startDate: number,
  endDate?: number,
  subClientId?: string
): Promise<{ assetState?: AssetState[]; error?: ApiError }> => {
  const queryParams: { [key: string]: any } = {
    clientId,
    subClientId,
    allItems: true,
    startDate,
  };
  if (endDate) {
    queryParams['endDate'] = endDate;
  }
  const response = await getRequest(assetStateUrl(assetId), {
    queryParams,
  });
  return {
    assetState: response?.data?.items,
    error: response?.error,
  };
};
